module.exports = __webpack_public_path__ + "img/debtia.9b6b1895.svg";